// Constants.
import * as PayProductsConstants from 'constants/PayProductsConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  isFetching: false,
  isFetched: false,
  isPaying: false,
  isPayingProductId: null,
  isPaid: false,
  products: [],
  activeProducts: [],
  paidProduct: null,
  message: '',
};

export default function products(state = initialState, action = {}) {
  switch (action.type) {
    case PayProductsConstants.LOAD_PRODUCTS_REQUEST:
      return {
        ...state,
        isFetching: true,
        isFetched: false,
        message: '',
      };
    case PayProductsConstants.LOAD_PRODUCTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        products: action.products,
        activeProducts: action.activeProducts,
        paidProduct: action.paidProduct,
      };
    case PayProductsConstants.LOAD_PRODUCTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        products: [],
        activeProducts: [],
        paidProduct: null,
      };
    case PayProductsConstants.PAY_PRODUCT_REQUEST:
      return {
        ...state,
        isPaying: true,
        isPayingProductId: action.productId,
        isPaid: false,
        message: '',
      };
    case PayProductsConstants.PAY_PRODUCT_SUCCESS:
      return {
        ...state,
        isPaying: false,
        isPayingProductId: null,
        isPaid: true,
      };
    case PayProductsConstants.PAY_PRODUCT_FAILURE:
      return {
        ...state,
        isPaying: false,
        isPaid: false,
        message: action.message,
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        isPaying: false,
        isPayingProductId: null,
        isPaid: false,
        products: [],
        activeProducts: [],
        paidProduct: null,
        message: '',
      };
    default:
      return state;
  }
}
